import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import {graphql } from 'gatsby';
import Layout from "../components/layout";
import Breadcrumb from '../components/breadcrumb';
import YearSelect from '../components/year-selector';
import GameRecord from '../components/GameRecord';
import MatchupRecord from '../components/MatchupRecord';
import { gameOutcomeWinner} from '../helpers/game';

const GameRecords = (query) => {
	// Get GraphlQL data
	const games = query.data.allGamesJson.nodes;
  const owners = query.data.allOwnersJson.nodes;

	const [yearLabels] = useState([...new Set(games.map(item => item.year))].reverse());
	const [items, setItems] = useState(10);
	const [year, setYear] = useState("All");
  const [playoff, setPlayoff] = useState(false);
  const [regular, setRegular] = useState(true);
	const [topScores, setTopScores] = useState([]);
	const [bottomScores, setBottomScores] = useState([]);
	const [topVictoryMargin, setTopVictoryMargin] = useState([]);
	const [bottomVictoryMargin, setBottomVictoryMargin] = useState([]);
	const [highestScoreLoss, setHighestScoreLoss] = useState([]);
	const [lowestScoreWin, setLowestScoreWin] = useState([]);
	const [mostPoints, setMostPoints] = useState([]);
	const [fewestPoints, setFewestPoints] = useState([]);


	
	useEffect(() => {

		let gameStats = [];
		let allScores = [];
		let filteredGames = games;
		
		if (!playoff) {
			filteredGames = filteredGames.filter(function (game) {
				return game.playoffTierType !== "WINNERS_BRACKET";
			});            
		}  
		
		if (!regular) {
			filteredGames = filteredGames.filter(function (game) {
				return game.playoffTierType !== "NONE";
			});            
		} 

		if (year !== 'All') {
			filteredGames = filteredGames.filter(function (game) {
				return game.year === parseInt(year);
			});  
		}

		filteredGames.forEach((game) => {
			gameStats.push(gameOutcomeWinner(game,owners));
		});

		// Get all scores in separate objects so we can find the max and min easily
		filteredGames.forEach(game=> {
			const teamA = game.team_a["0"];
			const teamB = game.team_b["0"];

			allScores.push({
				id: teamA.ownerId,
				name: _.find(owners, ['id', teamA.ownerId]).name,
				score: teamA.score,
				week: game.week,
				year: game.year,
				image: _.find(owners, ['id', teamA.ownerId]).image
			});
			allScores.push({
				id: teamB.ownerId,
				name: _.find(owners, ['id', teamB.ownerId ]).name,
				score: teamB.score,
				week: game.week,
				year: game.year,
				image: _.find(owners, ['id', teamB.ownerId]).image
			});
		});

		// Remove empty sets
		gameStats = _.compact(gameStats);

		allScores = _.sortBy(allScores, ['score']);
		setTopScores(() => _.orderBy(_.takeRight(allScores, items), ['score'], ['desc']));
		setBottomScores(() => _.take(allScores, items));

		setTopVictoryMargin(() => _.orderBy(_.takeRight(_.sortBy(gameStats, ['margin']), items), ['margin'], ['desc']));
		setBottomVictoryMargin(() => _.take(_.sortBy(gameStats, ['margin']), items));

		//TODO cambiar a incluir ties 
		setMostPoints(() => _.orderBy(_.takeRight(_.sortBy(gameStats, ['sumScore']), items), ['sumScore'], ['desc']));
		setFewestPoints(() => _.take(_.sortBy(gameStats, ['sumScore']), items));

		setHighestScoreLoss(() => _.orderBy(_.takeRight(_.sortBy(gameStats, ['scoreLose']), items), ['scoreLose'], ['desc']));
		setLowestScoreWin(() => _.take(_.sortBy(gameStats, ['scoreWin']), items));

	}, [playoff,regular,year,games,owners,items]);

	return (
			<Layout>
			<main className="container-fluid">
			 	<Breadcrumb title="Game Records"/>
				<div className="card mb-3">
					<div className="card-header"> 
						<div className='card-content'>
							<input type="checkbox" id="regular-season" value="regular-season" onChange={(e) => {setRegular(e.target.checked)}} checked={regular} /> <span className="checkbox-label">Regular Season</span>
							<input type="checkbox" id="playoffs" value="playoffs" onChange={(e) => {setPlayoff(e.target.checked)}} checked={playoff} /> <span className="checkbox-label">Playoffs</span>
							<br/><br/>
							<label>Number of Records to show</label>
							<select className="form-control" id="itemSelector" onChange={(e) => {setItems( e.target.value)}}>
								<option value="10">10</option>
								<option value="15">15</option>
								<option value="20">20</option>
								<option value="25">25</option>			
							</select>
							<br/>
							
							<YearSelect data={yearLabels} change={(e) => {setYear( e.target.value)}}/>
						</div>
          </div>
					<div className="card-body">
						<div className="row">
							<GameRecord data={topScores} label="Score" title="Top Scores"  />
							<GameRecord data={bottomScores} label="Score" title="Lowest Scores" />
						</div>
						<div className="row my-4">
							<MatchupRecord data={topVictoryMargin} label="Margin" show="Margin" title="Highest Victory Margins" />
							<MatchupRecord data={bottomVictoryMargin} label="Margin" show="Margin" title="Lowest Victory Margins" />
						</div>
						<div className="row my-4">
							<MatchupRecord data={mostPoints} label="Points" show="Points" title="Most Combined Points" />
							<MatchupRecord data={fewestPoints} label="Points" show="Points" title="Fewest Combined Points" />
						</div>
						<div className="row my-4">
							<MatchupRecord data={highestScoreLoss} label="Score" show="scoreLose"  title="Highest Score in a Loss" />
							<MatchupRecord data={lowestScoreWin} label="Score" show="scoreWin" title="Lowest Score in a Win" />
						</div>
					</div>
					<div className="card-footer small text-muted"></div>
					</div>
			</main>
			</Layout>
		);
};
export default GameRecords;

export const pageQuery = graphql`
{
  allGamesJson {
    nodes {
      id
      year
      winner
      week
      playoffTierType
      team_a {
        logo
        name
        owner
        ownerId
        rank
        score
      }
      team_b {
        logo
        name
        owner
        ownerId
        rank
        score
      } 
    }
  }
  allOwnersJson {
    nodes {
      fantasyname
      id
      image
      name
      status
    }
  }
}
`;
